var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "ai-check-container" }, [
    _c("div", { staticClass: "ai-header-banner" }, [
      _c("div", { staticClass: "banner-overlay" }),
      _c("div", { staticClass: "banner-content" }, [
        _vm._m(0),
        _c(
          "div",
          { staticClass: "banner-actions" },
          [
            _c(
              "el-button",
              {
                staticClass: "gradient-btn green-btn",
                attrs: { type: "success", icon: "el-icon-download" },
                on: {
                  click: function ($event) {
                    return _vm.handleCommand("exportExcel")
                  },
                },
              },
              [_vm._v("\n          Xuất Excel Thống Kê\n        ")]
            ),
          ],
          1
        ),
      ]),
    ]),
    _c("div", { staticClass: "ai-stats-grid" }, [
      _c("div", { staticClass: "stat-card blue" }, [
        _vm._m(1),
        _c("div", { staticClass: "stat-info" }, [
          _c("p", { staticClass: "stat-label" }, [
            _vm._v("Tổng giao dịch ghi nhận"),
          ]),
          _c("h3", { staticClass: "stat-value" }, [
            _vm._v(_vm._s(_vm.totalTransactions)),
          ]),
        ]),
      ]),
      _c("div", { staticClass: "stat-card green" }, [
        _vm._m(2),
        _c("div", { staticClass: "stat-info" }, [
          _c("p", { staticClass: "stat-label" }, [
            _vm._v("Giao dịch tiền vào (Credit)"),
          ]),
          _c("h3", { staticClass: "stat-value" }, [
            _vm._v(_vm._s(_vm.totalMoneyInTransactions)),
          ]),
        ]),
      ]),
      _c("div", { staticClass: "stat-card purple" }, [
        _vm._m(3),
        _c("div", { staticClass: "stat-info" }, [
          _c("p", { staticClass: "stat-label" }, [
            _vm._v("Giao dịch tiền ra (Debit)"),
          ]),
          _c("h3", { staticClass: "stat-value" }, [
            _vm._v(_vm._s(_vm.totalMoneyOutTransactions)),
          ]),
        ]),
      ]),
    ]),
    _c(
      "div",
      { staticClass: "glass-card mb-4" },
      [
        _c(
          "el-form",
          {
            staticClass: "modern-filter-form",
            attrs: { inline: true, model: _vm.dataSearch },
          },
          [
            _c(
              "el-form-item",
              { attrs: { label: "Chế độ xem" } },
              [
                _c(
                  "el-radio-group",
                  {
                    staticClass: "modern-radio-group",
                    on: { change: _vm.changeTypeMethod },
                    model: {
                      value: _vm.dataSearch.type,
                      callback: function ($$v) {
                        _vm.$set(_vm.dataSearch, "type", $$v)
                      },
                      expression: "dataSearch.type",
                    },
                  },
                  [
                    _c("el-radio-button", { attrs: { label: "day" } }, [
                      _vm._v("Theo ngày"),
                    ]),
                    _c("el-radio-button", { attrs: { label: "year" } }, [
                      _vm._v("Theo năm"),
                    ]),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm.dataSearch.type === "day"
              ? _c(
                  "el-form-item",
                  { attrs: { label: "Khoảng ngày" } },
                  [
                    _c("el-date-picker", {
                      staticClass: "modern-date-picker",
                      attrs: {
                        type: "daterange",
                        format: "dd-MM-yyyy",
                        "unlink-panels": "",
                        clearable: false,
                        "range-separator": "-",
                        "start-placeholder": "Bắt đầu",
                        "end-placeholder": "Kết thúc",
                      },
                      on: { change: _vm.changleData },
                      model: {
                        value: _vm.times,
                        callback: function ($$v) {
                          _vm.times = $$v
                        },
                        expression: "times",
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _vm.dataSearch.type === "year"
              ? _c(
                  "el-form-item",
                  { attrs: { label: "Chọn năm" } },
                  [
                    _c("el-date-picker", {
                      staticClass: "modern-date-picker-year",
                      attrs: {
                        type: "year",
                        format: "yyyy",
                        clearable: false,
                        placeholder: "Chọn năm",
                      },
                      on: { change: _vm.changleData },
                      model: {
                        value: _vm.dataSearch.year,
                        callback: function ($$v) {
                          _vm.$set(_vm.dataSearch, "year", $$v)
                        },
                        expression: "dataSearch.year",
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _c(
              "el-form-item",
              { attrs: { label: "Trường học" } },
              [
                _c(
                  "el-select",
                  {
                    staticClass: "modern-select school-select",
                    attrs: {
                      filterable: "",
                      clearable: "",
                      placeholder: "Tất cả các trường",
                    },
                    on: { change: _vm.changleData },
                    model: {
                      value: _vm.dataSearch.idSchool,
                      callback: function ($$v) {
                        _vm.$set(_vm.dataSearch, "idSchool", $$v)
                      },
                      expression: "dataSearch.idSchool",
                    },
                  },
                  _vm._l(_vm.schoolList, function (item) {
                    return _c("el-option", {
                      key: item.id,
                      attrs: {
                        value: item.id,
                        label: `${item.id} - ${item.schoolName}`,
                      },
                    })
                  }),
                  1
                ),
              ],
              1
            ),
            _c(
              "el-form-item",
              { attrs: { label: "Loại giao dịch" } },
              [
                _c(
                  "el-select",
                  {
                    staticClass: "modern-select",
                    attrs: {
                      filterable: "",
                      clearable: "",
                      placeholder: "Tất cả loại",
                    },
                    on: { change: _vm.changleData },
                    model: {
                      value: _vm.dataSearch.transferType,
                      callback: function ($$v) {
                        _vm.$set(_vm.dataSearch, "transferType", $$v)
                      },
                      expression: "dataSearch.transferType",
                    },
                  },
                  _vm._l(_vm.transferTypeList, function (item) {
                    return _c("el-option", {
                      key: item.id,
                      attrs: { value: item.value, label: item.label },
                    })
                  }),
                  1
                ),
              ],
              1
            ),
            _c(
              "el-form-item",
              { attrs: { label: "Phân loại GD" } },
              [
                _c(
                  "el-select",
                  {
                    staticClass: "modern-select",
                    on: { change: _vm.changleData },
                    model: {
                      value: _vm.dataSearch.belongOnekids,
                      callback: function ($$v) {
                        _vm.$set(_vm.dataSearch, "belongOnekids", $$v)
                      },
                      expression: "dataSearch.belongOnekids",
                    },
                  },
                  _vm._l(_vm.belongOnekidsList, function (item) {
                    return _c("el-option", {
                      key: item.id,
                      attrs: { value: item.value, label: item.label },
                    })
                  }),
                  1
                ),
              ],
              1
            ),
            _c(
              "el-form-item",
              { attrs: { label: "Số tài khoản" } },
              [
                _c("el-input", {
                  staticClass: "modern-input",
                  attrs: {
                    clearable: "",
                    placeholder: "Số tài khoản...",
                    "prefix-icon": "el-icon-bank",
                  },
                  on: { clear: _vm.changleData },
                  nativeOn: {
                    keyup: function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      )
                        return null
                      return _vm.changleData.apply(null, arguments)
                    },
                  },
                  model: {
                    value: _vm.dataSearch.accountNumber,
                    callback: function ($$v) {
                      _vm.$set(_vm.dataSearch, "accountNumber", $$v)
                    },
                    expression: "dataSearch.accountNumber",
                  },
                }),
              ],
              1
            ),
            _c(
              "el-form-item",
              { staticClass: "filter-actions" },
              [
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary", icon: "el-icon-search" },
                    on: { click: _vm.changleData },
                  },
                  [_vm._v("Lọc biểu đồ")]
                ),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "glass-card chart-container-card" },
      [
        _vm.loadTransactionVolumeChartDB
          ? _c("spinner-custom")
          : _c(
              "div",
              { staticClass: "chart-wrapper" },
              [
                _vm.showChartDB
                  ? _c("ChartBar", {
                      key: _vm.dataSearch.type,
                      attrs: {
                        checkLable: true,
                        chartData: _vm.dataTransactionVolumeChartDB.chartData,
                        options: _vm.dataTransactionVolumeChartDB.options,
                      },
                    })
                  : _vm._e(),
              ],
              1
            ),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "banner-left" }, [
      _c("div", { staticClass: "ai-icon-pulse" }, [
        _c("i", { staticClass: "el-icon-data-analysis" }),
      ]),
      _c("div", [
        _c("h1", { staticClass: "banner-title" }, [
          _vm._v("BIỂU ĐỒ SỐ LƯỢNG GIAO DỊCH"),
        ]),
        _c("p", { staticClass: "banner-subtitle" }, [
          _vm._v(
            "Phân tích tần suất và số lượng giao dịch biến động theo thời gian, hỗ trợ xuất báo cáo thống kê."
          ),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "stat-icon" }, [
      _c("i", { staticClass: "el-icon-chat-line-square" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "stat-icon" }, [
      _c("i", { staticClass: "el-icon-circle-check" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "stat-icon" }, [
      _c("i", { staticClass: "el-icon-circle-close" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }